




































import {Component, Vue, Watch} from "vue-property-decorator";
import debounce from "lodash/debounce";
import MillisecondDatePicker from "@/shared/components/MillisecondDatePicker/index.vue";
import ProvinceSelector from "@/modules/regions/ProvinceSelector/index.vue";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import {HistoryStockOutParams} from "@/modules/pickinglists/params";
import {PickingListStore} from "@/modules/pickinglists";
import EmployeeSelector from "@/shared/components/EmployeeSelector/index.vue";
import {EmployeeType} from "@/enums/type";

@Component({
    name: "HistoryStockOutSearch",
    components: {EmployeeSelector, EnumSelector, ProvinceSelector, MillisecondDatePicker}
})
export default class extends Vue {
    EmployeeType = EmployeeType;
    form = new HistoryStockOutParams();

    @Watch('form', { deep: true })
    onValuesChange(val: any) {
        this.handleChange(val);
    }

    handleChange = debounce(function (val) {
        PickingListStore.updatePickingListParams(val);
        PickingListStore.historyStockOut({ ...val, page: 1 })
    }, 500);
}
